export default {
  confirmDelete: {
    header: 'Zurücksetzen bestätigen',
    message:
    'Das Löschen dieses Parameters bewirkt, dass stattdessen der Parameter einer übergeordneten Anlage für {asset} gilt.\nFalls kein übergeordnete Anlage diesen Parameter definiert, wird der Standardwert verwendet.\n\nBist du sicher, dass du den Parameter \'{parameter}\' für \'{asset}\' löschen möchtest?',
  },
};
